import React, { useState, useEffect } from "react";
import { toJS } from "mobx";
import Button from "../Button";
import Link from "../Link";
import TechniquesSelect from "../result_notifications/TechniquesSelect";
import MatricesSelect from "../result_notifications/MatricesSelect";

export default function TrayToolbar({
  displayOptions,
  setDisplayOptions,
  defaultOptions,
  toggleLocationReport,
  selectedTrayCount,
  toggleMediaReport,
  discardTrays,
}) {
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const storageKey = "display_options";

  useEffect(() => {
    const options = {
      ...defaultOptions,
      ...JSON.parse(localStorage.getItem(storageKey) || "{}"),
    };
    setDisplayOptions(options);
  }, []);

  const saveOptions = (options) => {
    localStorage.setItem(storageKey, JSON.stringify(toJS(options)));
    setDisplayOptions(options);
  };

  return (
    <div
      className="basic-panel"
      style={{
        padding: 5,
        paddingLeft: 10,
        marginLeft: 0,
        backgroundColor: "#FAFAFA",
        borderRadius: 5,
      }}
    >
      <div className="btn-toolbar">
        <div className="btn-group">
          <label
            style={{
              marginBottom: 0,
              paddingBottom: 0,
              marginRight: 10,
              marginTop: 5,
              fontSize: "12pt",
            }}
          >
            <input
              type="checkbox"
              checked={displayOptions.showStateChangeDate || false}
              onChange={() => {
                saveOptions({
                  ...displayOptions,
                  showStateChangeDate: !!!displayOptions.showStateChangeDate,
                });
              }}
            />{" "}
            &nbsp; Show tray label?
          </label>
        </div>
        <div className="btn-group pull-right">
          <Button
            title="Show Location Report"
            onClick={toggleLocationReport}
            disabled={selectedTrayCount == 0}
          />
        </div>
        <div className="btn-group pull-right">
          <Button
            title="Show Media Report"
            onClick={toggleMediaReport}
            disabled={selectedTrayCount == 0}
          />
        </div>
        <div className="btn-group pull-right">
          <Button
            title="Discard Trays"
            onClick={discardTrays}
            disabled={selectedTrayCount == 0}
          />
        </div>
        <div className="btn-group" style={{ width: 230 }}>
          <select
            className="form-control"
            value={displayOptions.groupBy}
            onChange={(e) => saveOptions({ ...displayOptions, groupBy: e.target.value })}
          >
            <option value="due_date">Group by Due Date</option>
            <option value="scheduled_date">Group by Scheduled Date</option>
          </select>
        </div>
        <div className="btn-group" style={{ marginTop: 5, marginLeft: 10 }}>
          <Link onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}>
            <i className={showAdvancedOptions ? "fa fa-caret-up" : "fa fa-caret-down"} />
            &nbsp;&nbsp; Show Advanced Options
          </Link>
        </div>
      </div>
      {showAdvancedOptions && (
        <div className="btn-toolbar">
          <div className="btn-group" style={{ minWidth: 300 }}>
            <label
              style={{
                backgroundColor: "red",
                color: "white",
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 4,
                paddingBottom: 4,
                marginRight: 10,
              }}
            >
              <i className="fa fa-exclamation" />
              &nbsp; M
            </label>
            Priority Matrices:
            <MatricesSelect
              selectId={"tray_matrix_id"}
              matrix_ids={displayOptions.priorityMatrixIds || []}
              handleSelectChange={(options) => {
                saveOptions({
                  ...displayOptions,
                  priorityMatrixIds: options.map((o) => o.value),
                });
              }}
            />
          </div>
          <div className="btn-group" style={{ width: "100%" }}>
            <label
              style={{
                backgroundColor: "red",
                color: "white",
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 4,
                paddingBottom: 4,
                marginRight: 10,
              }}
            >
              <i className="fa fa-exclamation" />
              &nbsp; T
            </label>
            Priority Techniques:
            <TechniquesSelect
              selectId={"tray_technique_id"}
              technique_ids={displayOptions.priorityTechniqueIds || []}
              handleSelectChange={(options) => {
                saveOptions({
                  ...displayOptions,
                  priorityTechniqueIds: options.map((o) => o.value),
                });
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
